module.exports = __webpack_public_path__ + "static/img/spinner.a5a4685.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinner.gif
// module id = 297
// module chunks = 0 1 2 3 4 5 6 7 8 9